export type HeroTone =
  | 'home'
  | 'courses'
  | 'labs'
  | 'projects'
  | 'academy'
  | 'interviews'
  | 'events'
  | 'gigs'
  | 'mentors'
  | 'account'
  | 'admin'
  | 'contact';

const BLUE = {
  shell: 'from-blue-950 via-blue-800 to-sky-700',
  fade: 'from-blue-950/45',
  photoScrim: 'from-blue-950/90 via-blue-900/30',
  cta: 'from-blue-800 to-sky-700',
};

const THEMES: Record<HeroTone, { shell: string; fade: string; photoScrim: string; cta: string }> = {
  home: {
    shell: 'from-indigo-950 via-violet-800 to-sky-700',
    fade: 'from-indigo-950/40',
    photoScrim: 'from-indigo-950/90 via-violet-900/25',
    cta: 'from-violet-700 to-sky-700',
  },
  courses: {
    shell: 'from-violet-950 via-indigo-800 to-fuchsia-800',
    fade: 'from-violet-950/45',
    photoScrim: 'from-violet-950/90 via-indigo-900/30',
    cta: 'from-indigo-700 to-fuchsia-700',
  },
  labs: BLUE,
  projects: {
    shell: 'from-slate-950 via-cyan-900 to-blue-800',
    fade: 'from-slate-950/50',
    photoScrim: 'from-slate-950/90 via-cyan-900/30',
    cta: 'from-cyan-800 to-blue-700',
  },
  academy: BLUE,
  interviews: {
    shell: 'from-sky-950 via-cyan-800 to-blue-900',
    fade: 'from-sky-950/50',
    photoScrim: 'from-sky-950/90 via-sky-900/35',
    cta: 'from-sky-700 to-blue-800',
  },
  events: {
    shell: 'from-amber-950 via-orange-800 to-rose-800',
    fade: 'from-amber-950/45',
    photoScrim: 'from-amber-950/90 via-orange-900/30',
    cta: 'from-orange-700 to-rose-700',
  },
  gigs: {
    shell: 'from-rose-950 via-fuchsia-800 to-orange-900',
    fade: 'from-rose-950/45',
    photoScrim: 'from-rose-950/90 via-pink-900/30',
    cta: 'from-rose-700 to-fuchsia-700',
  },
  mentors: {
    shell: 'from-emerald-950 via-teal-800 to-lime-800',
    fade: 'from-emerald-950/45',
    photoScrim: 'from-emerald-950/90 via-teal-900/30',
    cta: 'from-emerald-700 to-teal-700',
  },
  account: BLUE,
  admin: {
    shell: 'from-slate-950 via-indigo-950 to-blue-900',
    fade: 'from-slate-950/50',
    photoScrim: 'from-slate-950/90 via-indigo-900/30',
    cta: 'from-indigo-800 to-slate-800',
  },
  contact: {
    shell: 'from-teal-950 via-cyan-800 to-sky-800',
    fade: 'from-teal-950/45',
    photoScrim: 'from-teal-950/90 via-cyan-900/30',
    cta: 'from-teal-700 to-cyan-700',
  },
};

export function heroShell(tone: HeroTone) {
  return `relative overflow-hidden bg-gradient-to-br ${THEMES[tone].shell} text-white`;
}

export function heroImageFade(tone: HeroTone) {
  return `absolute inset-0 bg-gradient-to-t ${THEMES[tone].fade} to-transparent`;
}

export function heroPhotoScrim(tone: HeroTone) {
  return `absolute inset-0 bg-gradient-to-t ${THEMES[tone].photoScrim} to-transparent`;
}

export function heroCtaBand(tone: HeroTone) {
  return `relative overflow-hidden bg-gradient-to-br ${THEMES[tone].cta} text-white`;
}
